import Page from './page.vue';
export default Page;


// WEBPACK FOOTER //
// ./src/components/page/index.js